import { Type, type Static } from '@sinclair/typebox';
import { PaginationQueryParamsSchema } from '../../shared/utils/pagination-query-params.schema';

export const GetParticipantsListParamsSchema = Type.Object({
  chat_id: Type.String({ minLength: 1, description: 'ID of the Chat to retrieve participants from.' }),
});

export const GetParticipantsListQuerySchema = PaginationQueryParamsSchema;

export const AddParticipantParamsSchema = Type.Object({
  chat_id: Type.String({ minLength: 1, description: 'The ID of the Chat to add the participant to.' }),
});

export const AddParticipantBodySchema = Type.Object(
  {
    user_id: Type.String({ minLength: 1, description: 'The ID of the User to add as participant.' }),
  },
  { additionalProperties: false },
);

export const RemoveParticipantParamsSchema = Type.Object({
  chat_id: Type.String({ minLength: 1, description: 'The ID of the Chat to remove the participant from.' }),
  user_id: Type.String({ minLength: 1, description: 'The ID of the User to remove from the chat.' }),
});

export type GetParticipantsListParams = Static<typeof GetParticipantsListParamsSchema>;
export type GetParticipantsListQuery = Static<typeof GetParticipantsListQuerySchema>;
export type AddParticipantParams = Static<typeof AddParticipantParamsSchema>;
export type AddParticipantBody = Static<typeof AddParticipantBodySchema>;
export type RemoveParticipantParams = Static<typeof RemoveParticipantParamsSchema>;
